<template>
  <div
    :class="{
      [$style.actionTypeChatPreview]: previewType === 'desktop',
    }"
  >
    <ActionTypeWidgetPreview v-if="previewType === 'desktop'">
      <section
        :class="$style.PFChat"
      >
        <ActionTypeChatPreviewHeader
          :avatar="avatarPreview"
          :operator-name="operatorName"
        />
        <div :class="$style.PFChatBody">
          <div :class="$style.PFChatBodyItem">
            <ActionTypeChatPreviewMessage
              v-if="messageNumber1"
            >
              {{ messageNumber1 }}
            </ActionTypeChatPreviewMessage>
          </div>
          <div :class="$style.PFChatBodyItem">
            <ActionTypeChatPreviewMessage
              v-if="messageNumber2"
            >
              {{ messageNumber2 }}
            </ActionTypeChatPreviewMessage>
          </div>
          <div
            v-for="(m, idx) in myAnswer"
            :key="idx"
            :class="[
              $style.PFChatBodyItem,
              $style.PFChatBodyItemMy,
            ]"
          >
            <ActionTypeChatPreviewMessage my>
              {{ m }}
            </ActionTypeChatPreviewMessage>
          </div>
        </div>
        <ActionTypeChatPreviewFooter
          :quick-answer-enabled="quickAnswerEnabled"
          :quick-answer-value="quickAnswerValue"
          :branding="branding"
          @submit="handleSubmit"
        />
      </section>
    </ActionTypeWidgetPreview>

    <section
      v-if="previewType === 'mobile'"
      :class="[
        $style.PFChat,
        $style.PFChatIsMobile,
      ]"
    >
      <ActionTypeChatPreviewHeader
        :avatar="avatarPreview"
        :operator-name="operatorName"
      />
      <div :class="$style.PFChatBody">
        <div :class="$style.PFChatBodyItem">
          <ActionTypeChatPreviewMessage
            v-if="messageNumber1"
          >
            {{ messageNumber1 }}
          </ActionTypeChatPreviewMessage>
        </div>
        <div :class="$style.PFChatBodyItem">
          <ActionTypeChatPreviewMessage
            v-if="messageNumber2"
          >
            {{ messageNumber2 }}
          </ActionTypeChatPreviewMessage>
        </div>
        <div
          v-for="(m, idx) in myAnswer"
          :key="idx"
          :class="[
            $style.PFChatBodyItem,
            $style.PFChatBodyItemMy,
          ]"
        >
          <ActionTypeChatPreviewMessage my>
            {{ m }}
          </ActionTypeChatPreviewMessage>
        </div>
      </div>
      <ActionTypeChatPreviewFooter
        :quick-answer-enabled="quickAnswerEnabled"
        :quick-answer-value="quickAnswerValue"
        :branding="branding"
        @submit="handleSubmit"
      />
    </section>
  </div>
</template>

<script>
import ActionTypeChatPreviewHeader from '@/components/Actions/ActionPreview/ActionTypeChatPreview/ActionTypeChatPreviewHeader.vue'
import ActionTypeChatPreviewFooter from '@/components/Actions/ActionPreview/ActionTypeChatPreview/ActionTypeChatPreviewFooter.vue'
import ActionTypeWidgetPreview from '@/components/Actions/ActionPreview/ActionTypeWidgetPreview.vue'
import ActionTypeChatPreviewMessage from '@/components/Actions/ActionPreview/ActionTypeChatPreview/ActionTypeChatPreviewMessage.vue'

export default {
  components: {
    ActionTypeChatPreviewHeader,
    ActionTypeChatPreviewFooter,
    ActionTypeWidgetPreview,
    ActionTypeChatPreviewMessage
  },
  props: {
    previewType: {
      type: String,
      default: 'desktop'
    },
    avatar: {
      type: [
        Object,
        process.client ? window.File : Object
      ],
      default: null
    },
    operatorName: {
      type: String,
      default: ''
    },
    messageNumber1: {
      type: String,
      default: ''
    },
    messageNumber2: {
      type: String,
      default: ''
    },
    quickAnswerEnabled: {
      type: Boolean,
      default: false
    },
    quickAnswerValue: {
      type: Array,
      default: () => ([])
    },
    branding: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    myAnswer: []
  }),
  computed: {
    avatarPreview () {
      if (!this.avatar) { return null }
      return this.avatar instanceof File
        ? URL.createObjectURL(this.avatar)
        : this.avatar.url
    }
  },
  methods: {
    handleSubmit (val) {
      if (val === 'clear') { this.myAnswer = []; return }
      if (val) {
        this.myAnswer.push(val)
      }
    }
  }
}
</script>

<style module lang="scss">
.actionTypeChatPreview {
  --s: 56px;

  all: unset;
  display: block;
  width: var(--s);
  height: var(--s);
  position: absolute;
  bottom: 40px;
  right: 40px;
  border-radius: 50%;
}

.PFChat {
  all: unset;
  position: absolute;
  right: 50%;
  bottom: calc(100% + 24px);
  display: flex;
  flex-direction: column;
  width: calc(312px * var(--pf-chat-scale));
  height: calc(555px * var(--pf-chat-scale));
  border-radius: calc(20px * var(--pf-chat-scale));
  background-color: #e5dcd6;
  box-shadow: 0 10px 20px -4px rgba(33, 33, 33, 0.04), 0 20px 40px -6px rgba(33, 33, 33, 0.04);
  overflow: auto;

  &.PFChatIsMobile {
    position: absolute;
    z-index: 9;
    inset: 0;
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
}

.PFChatBody {
  all: unset;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: calc(16px * var(--pf-chat-scale));
  gap: calc(8px * var(--pf-chat-scale));
}

.PFChatBodyItem {
  all: unset;
  display: flex;

  &.PFChatBodyItemMy {
    justify-content: flex-end;
  }
}
</style>
